'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = require('babel-helper-vue-jsx-merge-props');

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _lib = require('../../lib');

var _PropTypes = require('../../lib/PropTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SuiItemImage',
  mixins: [_lib.listenersMixin],
  description: 'An item can contain an image',
  props: {
    src: {
      type: String,
      required: true,
      description: 'Specifies the URL of the image'
    },
    size: (0, _PropTypes.Enum)(['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'], {
      type: String,
      description: 'An image may appear at different sizes (mini, tiny, small, medium, large, big, huge, massive)'
    }),
    href: {
      type: String,
      description: 'Specifies a linked document, resource, or location'
    }
  },
  render: function render() {
    var h = arguments[0];

    var ElementType = this.href ? 'a' : (0, _lib.getElementType)(this);
    return h(
      ElementType,
      (0, _babelHelperVueJsxMergeProps2.default)([(0, _lib.getChildProps)(this), {
        attrs: {
          href: this.href
        },
        'class': (0, _lib.classes)(this.size && 'ui ' + this.size, 'image')
      }]),
      [h(
        'img',
        {
          attrs: { src: this.src }
        },
        []
      )]
    );
  },

  meta: {
    parent: 'SuiItem'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-vue/dist/commonjs/views/Item/ItemImage.js
// module id = FwlB
// module chunks = 0